export const floatingTabHeight = 48;
export const floatingTabBottomGap = 8;
export const floatingTabContentGap = 24;
/** The expanded search bubble rests this far above its scene's bottom edge, plus the strip's fade inset. */
export const floatingSearchBubbleBottomGap = 9;
